<div class="paint-palette-swatch" [ngStyle]="getStyle()"></div>